if (document.querySelector(".alert")) {
    const alert = document.querySelector(".alert");
    alert.style.height = alert.clientHeight + "px";
    setTimeout(() => {
        //alert.style.height = 0;
        alert.classList.add("hide");
        setTimeout(() => {
          alert.remove();
        }, 300);
    }, 5000);
}
